import type {DynamoBindingProps} from './types';

export type {
  BindingContextKeyType,
  RichTextValue,
  DynamoBindingProps,
  VideoBindingProps,
} from './types';

/**
 * Copies binding prop values from  `fromProps` to `toProps`.
 *
 * The following properties are copied as long as their value in `fromProps`
 * is not `undefined`.
 * - innerHTML
 * - href
 * - dataWHref
 * - src
 * - alt
 * - media
 * - skuId
 * - productId
 * - optionSets
 * - optionValues
 * - token
 * - inventory
 * - repeater
 *
 * WARNING: This method mutates the `toProps` object!
 */
export function mut_copyBindingProps(
  fromProps: DynamoBindingProps,
  toProps: DynamoBindingProps
) {
  if (fromProps.innerHTML !== undefined) {
    toProps.innerHTML = fromProps.innerHTML;
  }

  if (fromProps.href !== undefined) {
    toProps.href = fromProps.href;
  }

  if (fromProps.dataWHref !== undefined) {
    toProps.dataWHref = fromProps.dataWHref;
  }

  if (fromProps.src !== undefined) {
    toProps.src = fromProps.src;
  }

  if (fromProps.alt !== undefined) {
    toProps.alt = fromProps.alt;
  }

  if (fromProps.media !== undefined) {
    toProps.media = fromProps.media;
  }

  if (fromProps.skuId !== undefined) {
    toProps.skuId = fromProps.skuId;
  }

  if (fromProps.productId !== undefined) {
    toProps.productId = fromProps.productId;
  }

  if (fromProps.optionSets !== undefined) {
    toProps.optionSets = fromProps.optionSets;
  }

  if (fromProps.optionValues !== undefined) {
    toProps.optionValues = fromProps.optionValues;
  }

  if (fromProps.token !== undefined) {
    toProps.token = fromProps.token;
  }

  if (fromProps.inventory !== undefined) {
    toProps.inventory = fromProps.inventory;
  }

  if (fromProps.repeater !== undefined) {
    toProps.repeater = fromProps.repeater;
  }
}
